/* eslint-disable */
/* Code generated by generator.ts DO NOT EDIT. */
// Generated: 04-11-2026 08:35:03

export enum SoortVakpositie {
    GEMEENSCHAPPELIJK = "Gemeenschappelijk",
    PROFIELVAK = "Profielvak",
    PROFIELVAK_STER = "Profielvak ster",
    PROFIELMODULE = "Profielmodule",
    SECTORVAK = "Sectorvak",
    KEUZEVAK = "Keuzevak",
    KEUZEVAK_STER = "Keuzevak ster",
    BEROEPSGERICHT_PROGRAMMA = "Beroepsgericht programma",
    BIJLAGE = "Bijlage"
}
